import { getRouteApi } from '@tanstack/react-router';

import { FloorPlansDashboard as EstateFloorPlansDashboard } from '@/features/estate-media/components/floor-plans-dashboard';
import { FloorPlansDashboard as ProjectFloorPlansDashboard } from '@/features/project-media/components/floor-plans-dashboard';

const route = getRouteApi('/_authenticated/_sidebar-layout');

export const FloorPlans = () => {
  const { estateId } = route.useParams();

  return estateId ? <EstateFloorPlansDashboard /> : <ProjectFloorPlansDashboard />;
};
